import { render, staticRenderFns } from "./BankModal.vue?vue&type=template&id=8623fdfe&"
import script from "./BankModal.vue?vue&type=script&lang=js&"
export * from "./BankModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports